import classes from "./address.module.css";
import { CiLocationArrow1 } from "react-icons/ci";
import { AiFillPhone } from "react-icons/ai";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Address(props) {
  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const id = localStorage.getItem("id");

  fetch("https://dc-luxury-default-rtdb.firebaseio.com/user.json")
    .then((res) => res.json())
    .then((data) => {
      const loadedData = [];
      for (const key in data) {
        loadedData.push({
          id: data[key].id,
          name: data[key].name,
          phoneNumber: data[key].phoneNumber,
          postalCode: data[key].postalCode,
          street: data[key].street,
        });
      }
      const filteredUser = loadedData.find((data) => data.id === id);
      setUserData(filteredUser);
    });

  if (!userData) {
    return (
      <div className={classes.error}>
        <p className={classes.retry}>Place an order to set address details</p>
        <Link className={classes.login} to="/store">
          Store
        </Link>
      </div>
    );
  }

  return (
    <Fragment>
      <div className={classes.mobile}>Only available on mobile</div>
      <section className={classes.section}>
        <span
          onClick={() => navigate("/profile", { replace: true })}
          className={classes.back}
        >
          <AiOutlineArrowLeft />
        </span>
        <h1>Your Delivery Details</h1>
        <hr />
        <div className={classes.address}>
          <address>
            <span>
              <CiLocationArrow1 />
            </span>
            {userData.street}
          </address>
        </div>
        <div className={classes.address}>
          <address>
            <span>
              <AiFillPhone />
            </span>
            {userData.phoneNumber}
          </address>
        </div>
        <div className={classes.address}>
          <address>
            <span>
              <CiLocationArrow1 />
            </span>
            {userData.postalCode}
          </address>
        </div>
      </section>
    </Fragment>
  );
}
